import { render } from "./ChurchProfile.vue?vue&type=template&id=e8ca518a&scoped=true"
import script from "./ChurchProfile.vue?vue&type=script&lang=js"
export * from "./ChurchProfile.vue?vue&type=script&lang=js"

import "./ChurchProfile.vue?vue&type=style&index=0&id=e8ca518a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8ca518a"]])

export default __exports__